import { Popper, Paper, Typography, Stack } from "@mui/material";
import LockOutlineIcon from "@mui/icons-material/LockOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

export default function PasswordCheckList({ open, anchorEl, value }) {
  if (!open || !anchorEl || !value) return null;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{ zIndex: 1300 }}
    >
      <Paper elevation={3} sx={{ p: 2 }}>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <LockOutlineIcon
            sx={{
              fontSize: "19px",
            }}
          />
          <Typography color="#053462" fontSize={"16px"} fontWeight={700}>
            Sua senha deve conter:
          </Typography>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} gap={1} mt={"10px"}>
          {value.length >= 8 ? (
            <CheckIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )}
          <Typography color="#053462" fontSize={"14px"} fontWeight={500}>
            Pelo menos 8 caracteres
          </Typography>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          {/[A-Z]/.test(value) ? (
            <CheckIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )}
          <Typography color="#053462" fontSize={"14px"} fontWeight={500}>
            Uma letra maiúscula
          </Typography>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          {/\d/.test(value) ? (
            <CheckIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )}
          <Typography color="#053462" fontSize={"14px"} fontWeight={500}>
            Um número
          </Typography>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          {/[!@#$%^&*]/.test(value) ? (
            <CheckIcon color="success" />
          ) : (
            <CloseIcon color="error" />
          )}
          <Typography color="#053462" fontSize={"14px"} fontWeight={500}>
            Um caractere especial (!@#$%...)
          </Typography>
        </Stack>
      </Paper>
    </Popper>
  );
}
